module.exports = __webpack_public_path__ + "img/icon-close.66686f21.svg";